import React, { Fragment, useState } from 'react';
import {
  Box,
  ButtonWithAction,
  Cluster,
  CollapsibleSection,
  Detail,
  Motion,
  SolidDivider,
  Stack,
  Text,
} from '@thecb/components';
import {
  formatPrice,
  titleCase,
  formatWithParentheses,
} from '../../utils/helpers';

export const CartItem = ({
  id,
  name,
  subtotal,
  total,
  isNegativeAmount,
  externalAttributes,
  remove,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const handleRemoveItemClick = (event) => {
    event.stopPropagation();
    remove(id);
  };

  const formattedSubtotal = isNegativeAmount
    ? formatWithParentheses(formatPrice(subtotal))
    : formatPrice(subtotal);
  const formattedTotal = isNegativeAmount
    ? formatWithParentheses(formatPrice(total))
    : formatPrice(total);
  const showFullAmount = subtotal !== total;
  const titleSection = (
    <Cluster justify="space-between" align="center">
      <Text>{name}</Text>
      <Cluster justify="flex-end" align="center" childGap="1rem">
        <Box padding="0" width="12rem">
          <Stack childGap=".25rem">
            <Text weight="600">{formattedSubtotal}</Text>
            {showFullAmount && <Text>Full Amount: {formattedTotal}</Text>}
          </Stack>
        </Box>
        <ButtonWithAction
          text="Remove Item"
          variant="warning"
          action={handleRemoveItemClick}
          dataQa="Remove Item"
          textExtraStyles="font-size: 1rem;"
        />
      </Cluster>
    </Cluster>
  );

  return (
    <Fragment>
      <Box padding="0">
        <CollapsibleSection
          supportsTouch={false}
          isOpen={isOpen}
          title={titleSection}
          initiallyOpen={false}
          toggleSection={() => setIsOpen(!isOpen)}
          customTitle={true}
        >
          <Motion
            variants={{
              open: { opacity: 1 },
              closed: { opacity: 0 },
            }}
            initial={'open'}
          >
            <Box
              padding=".5rem"
              background="#eee"
              data-testid="cart-item-attributes"
            >
              Item Attributes:
              {externalAttributes &&
                Object.entries(externalAttributes).map(([key, value]) => (
                  <Detail key={key} margin="0px 0px 0px 20px">
                    {titleCase(key)}: {value}
                  </Detail>
                ))}
            </Box>
          </Motion>
        </CollapsibleSection>
      </Box>
      <SolidDivider />
    </Fragment>
  );
};
